<template>
  <div class="el-popper industry-dropdown" :style="{ minWidth: '210px' }">
    <el-scrollbar v-if="computedList.length != 0" tag="ul" ref="scrollbar" wrap-class="search-scroll_wrap">
      <li v-for="(item, index) in computedList" :key='index' @click="onSelect(item.value)" :class="check(item.value) ? 'industry-item selected' : 'industry-item'">{{item.label}}</li>
    </el-scrollbar>
  </div>
</template>

<script type="text/babel">
  import ElScrollbar from 'element-ui/lib/scrollbar';
  export default {
    props: {
      value: {
        default: []
      },
      options: {
        default() {
          return [];
        }
      }
    },
    inject: ['select'],
    data() {
      return {
        minWidth: '',
      };
    },
    computed: {
      computedList() {
        return this.options.map(item => {
          return item;
        });
      }
    },
    methods: {
      onSelect(val) {
        this.$emit('input', val);
        this.select.visible = false;
      },
      check(val) {
        if (this.value===val) {
          return true;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .industry-dropdown {
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin:  0;
    padding: 0 10px 10px;
    z-index: 3000 !important;
  }

  .industry-item {
    font-size: 14px;
    padding: 0 20px;
    padding-left: 4px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #5a5e66;
    height: 34px;
    line-height: 34px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
  }
  .industry-item.selected {
    color: var(--theme-color);
  }
  .industry-item.hover,
  .industry-item:hover {
    background: #f5f7fa;
  }
</style>




// WEBPACK FOOTER //
// src/components/clickSelect/themeSelect.vue